import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class ColorPanel extends Component {
	constructor(props) {
		super(props);

		const { color, selectedData } = this.props;

		let selected = color.filter(c => {
			return c.id == selectedData;
		})[0];

		this.state = {
			selected: selected,
		};

		this.onClick = this.onClick.bind(this);
	}

	onClick(c) {
		const { onSelectValue } = this.props;

		this.setState({
			selected: c,
		});

		onSelectValue(c);
	}

	componentWillReceiveProps(nextProps) {
		const { selectedData, color } = nextProps;

		let selected = color.filter(c => {
			return c.id == selectedData;
		})[0];

		this.setState({
			selected: selected,
		});
	}

	render() {
		const { color, disabled } = this.props;

		const panel = color.map((c, index) => {
			let style = { backgroundColor: c.color },
				classes = classnames(
					'color-block',
					{
						selected: this.state.selected
							? this.state.selected.id == c.id
							: index == 0,
					},
					{ disabled: disabled }
				);

			return (
				<span
					key={c.id}
					style={style}
					className={classes}
					onClick={() => {
						return disabled ? null : this.onClick(c);
					}}
				/>
			);
		});

		const classesPanels = ['color-panel'];
		if (disabled) classesPanels.push('color-panel-disabled');
		return <div className={classesPanels.join(' ')}>{panel}</div>;
	}
}

ColorPanel.propTypes = {
	color: PropTypes.array.isRequired,
	selectedData: PropTypes.string,
	onSelectValue: PropTypes.func.isRequired,
};
